import AwProgressIndicatorViewModel from 'viewmodel/AwProgressIndicatorViewModel'
import { DesBaseCatalogAcc } from '../utils/des-base-catalog-acc';

export default class DesCatalogProgressBar extends DesBaseCatalogAcc {
    constructor() {
        super(AwProgressIndicatorViewModel);
    }

    getProps() {
        return {
            name: 'catalog'
        };
    }

    static get observedAttributes() {
        return ['accsessionid', 'acc-session-id'];
    }
}

if (!window.customElements.get('des-catalog-progress-bar')) {
    window.customElements.define('des-catalog-progress-bar', DesCatalogProgressBar);
}
